export function updateStyleButtons(selectedStyle) {
  const container = getContainer()
  if (!container) return
  
  const styleButtons = getStyleButtons(container)
  styleButtons.forEach(element => {
    updateButton(element, selectedStyle)
  })
}

function getContainer() {
  return document.getElementById('style-picker-container')
}

function getStyleButtons(container) {
  return container.querySelectorAll('[data-controller~="style-picker"]')
}

function updateButton(element, selectedStyle) {
  const controller = window.Stimulus?.getControllerForElementAndIdentifier(element, 'style-picker')
  controller?.updateSelection(selectedStyle)
}
